import React from 'react';

export const EditorContext = React.createContext();

export const useEditorContext = () => React.useContext(EditorContext);
